import { FC, ReactElement, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { clearAktivitetState } from 'store/aktivitetSlice';

import { RaaDialog } from 'raa-react';

import { Aktivitet } from 'models';

import { useDeleteAktivitetMutation } from 'api/endpoints/aktivitetPreliminarSlice';

interface DeleteAktivitetDialogProps {
  eTag: string;
  aktivitet: Aktivitet;
  unsetDialog: () => void;
}

const DeleteAktivitetDialog: FC<DeleteAktivitetDialogProps> = ({ eTag, aktivitet, unsetDialog }): ReactElement => {
  const [error, setError] = useState<string>();
  const navigate = useNavigate();

  const [deleteAktivitet, { isLoading: deleteAktivitetIsLoading, isSuccess: deleteAktivitetIsSuccess }] =
    useDeleteAktivitetMutation();

  const deleteAktivitetIsSuccessRef = useRef<boolean>();
  deleteAktivitetIsSuccessRef.current = deleteAktivitetIsSuccess;

  const handleDelete = async (eTag: string, aktivitet?: Aktivitet): Promise<void> => {
    setError('');

    if (!aktivitet) {
      clearAktivitetState();
      navigate('/', { replace: true });
      unsetDialog();
    } else {
      await deleteAktivitet({
        aktivitetId: aktivitet.aktivitet_id,
        eTag
      });

      if (deleteAktivitetIsSuccessRef.current) {
        navigate('/', { replace: true });
        unsetDialog();
      }
    }
  };

  return (
    <RaaDialog
      cancel={unsetDialog}
      proceed={error ? undefined : () => handleDelete(eTag, aktivitet)}
      close={unsetDialog}
      header={error ? 'Något gick fel!' : 'Vill du radera aktiviteten?'}
      proceedButtonText="radera"
      cancelButtonText={error ? 'stäng' : 'avbryt'}
      showLoadingSpinner={deleteAktivitetIsLoading}
      ariaDescribedBy="dialog-description"
    >
      {error && (
        <p id="dialog-description" className="tw-mt-8">
          {error}
        </p>
      )}
    </RaaDialog>
  );
};

export default DeleteAktivitetDialog;
